export const ProfileSection = ({children, className = ''}) => {
  return (
    <div
      className={`bg-white border border-gray-200 rounded-lg px-4 py-2 max-w-2xl shadow-sm ${className}`}
      style={{ paddingBottom: '1.2rem' }}
    >
      {children}
    </div>
  );
}